<template>
  <div class="c-detail-follow-style">
    <p class="concat-add-btn-con ">
      <el-button class="global-btn primary" type="primary" @click="whiteReport" size="small" v-if="firmInfo.report_process_status === 1 && baseInfo.allow_report" v-permission="'customer.detail.index.report'">报备</el-button>
      <el-button class="global-btn primary" type="primary" @click="openTakeLook(null)" size="small" v-if="firmInfo.report_process_status !== 1 && baseInfo.allow_look" v-permission="'customer.detail.index.look'">带看</el-button>
    </p>
    <cu-table :data="data" :pageData="condition" :isLoading="isLoading" @currentChange="currentChange" class="detail-buss-table-style">
      <el-table-column label="商机状态" min-width="100">
        <template slot-scope="scope">
          {{scope.row.business_stage_name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="项目" min-width="150">
        <template slot-scope="scope">
          {{scope.row.project_name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="创建人" min-width="90">
        <template slot-scope="scope">
          {{scope.row.creator_name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="140">
        <template slot-scope="scope">
          <span v-analysis-time="scope.row.created_at"></span>
        </template>
      </el-table-column>
      <el-table-column label="最近跟进内容" min-width="140">
        <template slot-scope="scope">
          <p class="apply-remark" :title="scope.row.latest_follow_up_content">{{scope.row.latest_follow_up_content}}</p>
        </template>
      </el-table-column>
      <el-table-column label="最后跟进时间" min-width="140">
        <template slot-scope="scope">
          <span v-analysis-time="scope.row.created_at"></span>
        </template>
      </el-table-column>
      <template slot="operate">
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope" >
            <div class="table-operation">
              <a class="ope-item" @click="bussinessDetail(scope.row.id)" v-permission="'customer.business.detail'">详情</a>
              <a class="ope-item" @click="toFollowUp(scope.row)" v-if="scope.row.allow_follow_up" v-permission="'customer.business.detail.follow'">写跟进</a>
              <a class="ope-item" @click="openTakeLook(scope.row)" v-if="scope.row.allow_look && firmInfo.report_process_status === 1"  v-permission="'customer.detail.index.look'">写带看</a>
              <a class="ope-item" @click="openSubstrib(scope.row)" v-if="scope.row.allow_recognition" v-permission="'customer.order.detail.recognition'">认筹</a>
              <a class="ope-item" @click="openOrder(scope.row)" v-if="scope.row.allow_order" v-permission="'customer.order.detail.subscription'">认购</a>
            </div>
          </template>
        </el-table-column>
      </template>
    </cu-table>
    <ApproveRefuseModal title="放弃商机" :maxLength="200" label="放弃原因" titleDesc="放弃商机后不可再跟进，此操作不可恢复" v-model="isGiveUp" @confirm='confirmGiveUp' />
  </div>
</template>
<script>
import {bussChangeStatus} from '@/api/workflow';
import {customeBussinessList} from  '@/api/custome';
import CuTable from '@/components/cTable';
import { mapState } from 'vuex';
export default {
  name: 'BussinessInfo',
  props: {
    customeId: String | Number,
    baseInfo: Object,
    emitName: String,
    activeName: String,
  },
  components: {
    CuTable,
    ApproveRefuseModal: resolve=>(require(["@/components/refuseModal"],resolve)),
  },
  data () {
    return {
      data: [],
      condition: {
        page: 1,
        per_page: 10,
        total: 0
      },
      isLoading: false,
      hasDetailPermission: false,
      isGiveUp: false
    }
  },
  created () {
    this.$store.dispatch('user/initGlobalCompany');
  },
  async mounted () {
    this.initList();
    this.hasDetailPermission = await this.$store.dispatch('user/hasPermission', 'customer.business.detail');
  },
  computed: {
    ...mapState({
      firmInfo: state => state.user.companyInfo
    })
  },
  methods: {
    refrensh () {
      this.condition.page = 1;
      this.initList();
    },
    whiteReport () {
      const params = {
        type: 'new',
        customer_name: this.baseInfo.name,
        customer_id: this.baseInfo.id,
        tabActiveName: this.activeName
      }
      this.$EventBus.$emit(this.emitName, {category: 'report', params});
    },
    openTakeLook (row) {
      const params = {
        type: 'new',
        customer_name: this.baseInfo.name,
        customer_id: this.baseInfo.id,
        tabActiveName: this.activeName,
        reportType: row ? 'bussiness' : 'customer'
      }
      if (row) {
        params.project_id = row.project_id;
        params.project_name = row.project_name;
        params.bussinessId= row.id;
      }
      this.$EventBus.$emit(this.emitName, {category: 'takeLook', params});
    },
    openSubstrib (row) {
      this.$EventBus.$emit(this.emitName, {isOpen: true, category: 'confess', params: {
        bussinessId: row.id,
        tabActiveName: this.activeName,
        subscribeType: 'bussiness'
      }});
    },
    openOrder (row) {
      this.$EventBus.$emit(this.emitName, {isOpen: true, category: 'subscribe', params: {
        bussinessId: row.id,
        tabActiveName: this.activeName,
        subscribeType: 'bussiness'
      }});
    },
    // 写跟进-跳转
    toFollowUp (row) {
      let info = {};
      ['customer_id', 'customer_name', 'contact_id', 'contact_name', 'contact_tel', 'id'].map(v => info[v] = row[v]);
      this.$EventBus.$emit(this.emitName, {category: 'follow', params: {
        followType: 'bussiness',
        info
      }});
    },
    // 初始化联系人列表
    async initList () {
      if (!this.customeId) return null;
      this.isLoading = true;
      try {
        const res = await customeBussinessList(this.customeId, {
          ...this.condition,
          customerId: this.customeId
        })
        this.data = res.data || [];
        this.$set(this.condition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试')
      } finally {
        this.isLoading = false;
      }
    },
    changeStatus (row) {
      this.row = row;
      this.isGiveUp = true;
    },
    async confirmGiveUp (content) {
      try {
        await bussChangeStatus(this.row.id, {
          content
        });
        this.$message.success('提交成功');
        this.isGiveUp = false;
        this.initList();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    bussinessDetail (id) {
      this.$EventBus.$emit(this.emitName, {category: 'bussinessDetail', params: {
        bussinessId: id,
        tabActiveName: this.activeName
      }});
    },
    currentChange (current) {
      this.$set(this.condition, 'page', current);
      this.initList();
    }
  }
}
</script>
<style scoped lang="less">
.c-detail-follow-style{
  .box();
  height: calc(100VH - 220px);
  -webkit-box-orient: vertical;
  .detail-buss-table-style{
    .boxFlexAll();
  }
  .concat-add-btn-con{
    text-align: right;
    width: 100%;
    padding: 10px 20px;
  }
}
</style>